import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
/**
 * Сервис, для храниения объектов в LocalStorage браузера.
 */
export class StoreService {
    constructor() { }
    /**
     * Сохраняет объект в LocalStorage браузера.
     * @param object Объект, который будет сконвертирован в строку JSON
     * @param name Имя поля, для сохранения в базе.
     */
    save(object:any, name:string):boolean{
        const jsObject:string  = JSON.stringify(object);
        if(typeof jsObject == "string" && jsObject.length > 0 && name ) {
            localStorage.setItem(name, jsObject);
            return true;
        } else return false;
    }
    /**
     * Возвращает объект по имени поля.
     * @param name Имя поля
     */
    get(name:string):false|object{
        const jsObject:string = localStorage.getItem(name);
        if(typeof jsObject == "string" && jsObject.length ) {
            const object = JSON.parse(jsObject);
            if(object) {
                return object;
            } else return false;
        } else return false;
    }
    /**
     * Удялет объект из LocalStorage
     * @param name 
     */
    remove(name:string):void {
        localStorage.removeItem(name);
    }
}